import apiClient from "./axios"

export const getEmployeeDepartments = async (params = {}) => {
  const { data } = await apiClient.get("/employee-departments", { params })
  return data
}

export const getEmployeeDepartment = async id => {
  const { data } = await apiClient.get(`/employee-departments/${id}`)
  return data
}

export const createEmployeeDepartment = async departmentData => {
  const { data } = await apiClient.post("/employee-departments", departmentData)
  return data
}

export const editEmployeeDepartment = async ({ id, ...departmentData }) => {
  const { data } = await apiClient.patch(`/employee-departments/${id}`, departmentData)
  return data
}

export const deleteEmployeeDepartment = async id => {
  const { data } = await apiClient.delete(`/employee-departments/${id}`)
  return data
}

export const getAllEmployeeDepartments = async (params = {}) => {
  const { data } = await apiClient.get("/employee-departments", {
    params: { ...params, all: true },
  })
  return data
}

export const getTrashedEmployeeDepartments = async (params = {}) => {
  const { data } = await apiClient.get("/employee-departments/trashed", { params })
  return data
}

export const restoreEmployeeDepartment = async id => {
  const { data } = await apiClient.post(`/employee-departments/${id}/restore`)
  return data
}
